<template>
  <div>
    <search-nav @handleSearch="onClickSearch">
      <div class="search-layout w-full grid col-gap-4 flex-wrap xl:flex">
        <component
          v-for="(component, index) in stdSearchComponents"
          :key="index"
          v-if="showSearchNavItem(component['options'])"
          :is="component['component']"
          :label="component['label']"
          :query="component['query']"
          :options="component['options']"
          :onClickSearch="onClickSearch"
          v-model="nav.value[component['value']]"
        />
      </div>
    </search-nav>

    <div>
      <div class="w-full flex justify-between">
        <div class="flex mr-auto mb-4">
          <vs-select v-model="perPage" class="mr-4" style="width: 110px;">
            <vs-select-item v-for="v in [10, 20, 30, 50]" :key="v" :text="`${v}개씩 보기`" :value="v" />
          </vs-select>
        </div>
        <div>
          <vs-button v-if="hasCreatePermission" class="" color="secondary" @click="onClickCreate">신규등록</vs-button>
        </div>
      </div>

      <div class="w-full overflow-x-auto">
        <div class="list">
          <div class="list-header list-grid">
            <div>No.</div>
            <div>사업장명</div>
<!--            <div>담당부서</div>-->
            <div>업체명</div>
            <div>사업자등록번호</div>
            <div>대표자</div>
            <div>담당자</div>
            <div>연락처</div>
          </div>
          <div class="list-body">
            <div v-for="(data, index) in paginationList"
                 :key="index"
                 class="list-grid"
                 @click="onClickItem(data)">
              <template>
                <div>{{ getItemNumber(index) }}</div>
                <div>{{ getFieldNames(data.fields) }}</div>
<!--                <div>{{ data.담당부서 }}</div>-->
                <div>{{ data.com_name || '-' }}</div>
                <div>{{ data.com_number || '-' }}</div>
                <div>{{ data.com_ceo || '-' }}</div>
                <div>{{ data.director || '-' }}</div>
                <div>{{ data.phone || '-' }}</div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="lastPage" v-model="page" @change="loadCompanyList"></k-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import searchComponent from "@/views/list/components/include";
import KPagination from "@/components/kPagination/kPagination.vue";
import List from "@/views/boards/single-page/1008/List.js";

export default {
  components: {
    KPagination,
    SearchNav
  },
  props: {
    board: Object,
    header: Object,
    value: Object,
    mode: {
      type: String,
      default: "list"
    }
  },
  data() {
    return {
      boardId: 1008,
      nav: { value: {}, options: { 사업장명: [], 상태: [] } },
      page: 1,
      lastPage: 1,
      perPage: 10,
      total: 0,
      allList: [],
      isLoadingFromQuery: false,
    };
  },
  computed: {
    stdSearchComponents() {
      const components = List.components();
      return components ? components.map(component => ({
        ...component,
        component: searchComponent[component['component']]
      })) : [];
    },
    paginationList() {
      return this.allList;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    // 1008 게시판의 권한
    permission() {
      const boards = this.$store.state.member.memberInfo.boards;
      if (boards) {
        const board = boards.find((b) => Number(b.id) === Number(this.boardId));
        return { ... board.pivot };
      }
      return { c: 0, r: 0, u: 0, d: 0, v: 0 };
    },
    // 시스템 관리자 여부
    isSuperUser() {
      return this.$store.state.member.memberInfo.is_superuser;
    },
    // 작성 권한이 있는지 여부
    hasCreatePermission() {
      return this.permission.c && this.isSuperUser;
    },
  },
  watch: {
    perPage() {
      if (!this.isLoadingFromQuery) {
        this.page = 1;
      }
      this.loadCompanyList();
      this.updateQueryParams();
    },
    page() {
      this.loadCompanyList();
      this.updateQueryParams();
    },
    '$route.query': {
      handler(newQuery) {
        this.loadStateFromQuery(newQuery);
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.isLoadingFromQuery = true;
    this.loadStateFromQuery(this.$route.query);
    this.loadCompanyList();
    this.updateQueryParams();
    this.$nextTick(() => {
      this.isLoadingFromQuery = false;
    });
  },
  methods: {
    async loadCompanyList() {
      const params = {
        page: this.page,
        perPage: this.perPage,
        projectId: this.$route.params.proj_id,
      };

      const filter = (this.nav.value && this.nav.value.column) ? this.nav.value.column : null;
      if (filter && filter.keyword) {
        if (filter.head === '업체명') {
          params.comName = filter.keyword;
        } else if (filter.head === '대표자') {
          params.comCeo = filter.keyword;
        } else if (filter.head === '담당자') {
          params.director = filter.keyword;
        } else if (filter.head === '연락처') {
          params.phone = filter.keyword;
        } else if (filter.head === '사업자번호') {
          params.comNumber = filter.keyword;
        }
      }

      const response = await this.$store.dispatch('company/LOAD_COMPANY_LIST', params);
      this.lastPage = response.last_page || 1;
      this.total = response.total || 0;
      this.allList = this.$store.state.company.companyList;
    },
    onClickSearch() {
      this.page = 1;
      this.loadCompanyList();
      this.updateQueryParams();
    },
    onClickItem(data) {
      this.$router.push({
        name: 'page-company-management-detail',
        params: { proj_id: this.$route.params.proj_id, id: data.id },
        query: this.$route.query
      });
    },
    showSearchNavItem(options) {
      if (options && options.visibleKeyValue) {
        for (const keyValue of options.visibleKeyValue) {
          const key = Object.keys(keyValue)[0];
          const value = keyValue[key];
          const navValue = this.findJsonDataWithDottedPath(this.nav.value, key);
          if (navValue !== value) {
            if (Array.isArray(navValue) && navValue.toString() === value) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
      return true;
    },
    getFieldNames(fields) {
      const fieldNames = fields.map(field => field.field_name);
      return fieldNames.join(', ');
    },
    onClickCreate() {
      this.$router.push({
        name: 'page-company-management-create',
        params: { proj_id: this.$route.params.proj_id },
        query: this.$route.query
      });
    },
    getItemNumber(index) {
      return this.total - ((this.page - 1) * this.perPage) - index;
    },
    updateQueryParams() {
      const query = { ...this.$route.query };

      // 페이지 번호 설정
      query.page = this.page.toString();
      query.perPage = this.perPage.toString();

      // 검색 조건 설정
      if (this.nav.value && this.nav.value.column) {
        if (this.nav.value.column.head) {
          query.ck_t = this.nav.value.column.head;
        } else {
          delete query.ck_t;
        }

        if (this.nav.value.column.keyword) {
          query.ck_k = this.nav.value.column.keyword;
        } else {
          delete query.ck_k;
        }
      } else {
        delete query.ck_t;
        delete query.ck_k;
      }

      // 현재 URL과 다른 경우에만 라우터 변경
      const currentQuery = JSON.stringify(this.$route.query);
      const newQuery = JSON.stringify(query);

      if (currentQuery !== newQuery) {
        this.$router.replace({ query }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
    loadStateFromQuery(query) {
      if (!query) return;

      this.isLoadingFromQuery = true; // URL에서 로드 중임을 표시

      // 페이지 번호와 페이지당 항목 수 복원
      if (query.page) {
        this.page = parseInt(query.page) || 1;
      }

      if (query.perPage) {
        this.perPage = parseInt(query.perPage) || 10;
      }

      // 검색 조건 복원
      if (query.ck_t || query.ck_k) {
        if (!this.nav.value.column) {
          this.nav.value.column = {};
        }

        if (query.ck_t) {
          this.nav.value.column.head = query.ck_t;
        }

        if (query.ck_k) {
          this.nav.value.column.keyword = query.ck_k;
        }
      }

      // 다음 tick에서 플래그 해제 (모든 watcher 실행 완료 후)
      this.$nextTick(() => {
        this.isLoadingFromQuery = false;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.list {
  text-align: center;
  .list-header {
    font-weight: 700;
    & > div {
      background-color: #f5f5f5;
      border-top: 1px solid #e0e0e0;
      border-bottom: 1px solid #e0e0e0;
    }
  }
  .list-body > div:hover {
    background-color: #f5f5f5;
    font-weight: bold;
  }
  .list-grid {
    display: grid;
    grid-template-columns: 60px repeat(6, minmax(140px, 1fr));
    & > div {
      padding: 10px 4px;
      text-align: center;
    }
  }
}
</style>
